import apiUrl from '../src/constants'
import axios from 'axios';
import commonFunction from './commonFunction'

export default {

  async userTracker(inputData) {
    try {
      
      inputData.meta.event= (inputData.meta && inputData.meta.event)?inputData.meta.event.replaceAll('/',' '):'';
      inputData.meta.event= (inputData.meta && inputData.meta.event)?inputData.meta.event.trim():'';
     
       let options = {
        method: 'POST',
        'url': apiUrl.user_tracker + 'UserTracker',
        'headers': commonFunction.getusertoken(),
        'data': inputData
      };
      await axios(options)
        .then( response => {
        //  console.log("UserTracker Request ", options);
        //   console.log("UserTracker response ", response);
          if (response.data.code == 100) {
            //return response.data;
            let input = {
              "log_type": "Success",
              "message": response.data.message,
              "data": response.data,
              "created_by": "UserTracker"
            };
            //   var result = await this.generatelogs(input);
            return input;
          } else {
            let input = {
              "log_type": "CatchedError",
              "message": response.data.message,
              "data": response.data,
              "created_by": "UserTracker",
              "shippingid": inputData.meta.shippingid
            };
            console.log(errorResult);
            return errorResult;
          }
        });
    } catch (error) {
      let input = {
        "log_type": "CatchedError",
        "message": "Error in userTracker Api in authFuction,js page ",
        "data": error,
        "created_by": "UserTracker",
        "shippingid": inputData.meta.shippingid
      };
      var errorResult = await this.generatelogs(input);
      console.log(errorResult);
      return errorResult;
    }
  },

  async generatelogs(inputData) {
    try {
      await axios({
          method: 'POST',
          'url': apiUrl.api_url + 'generatelogs',
          'headers': commonFunction.getusertoken(),
          'data': inputData
        })
        .then(response => {
          return response;
        });
    } catch (error) {
      console.log("Error in generatelogs Api in authFuction,js page : ", error);
      return error;
    }
  },

  //Currently Not In Use userTrackerBulk 
  async userTrackerBulk(userTrackerObj) {
    try {
      let inputDataReq = {
        "projectname": userTrackerObj.projectname,
        "type": "web",
        "userid": userTrackerObj.userid,
        "username": userTrackerObj.username,
        "olduserid": userTrackerObj.olduserid,
        "routeurl": userTrackerObj.trackurl,
        "meta": {
          "event": userTrackerObj.eventTrack,
          "shippingid": userTrackerObj.shippingIds
        }
      };
      this.userTracker(inputDataReq);

    } catch (error) {
      console.log("userTrackerBulk Catched Error ", error);
    }
  },

  //      userTrackerBulkEdit  
  async userTrackerBulkEdit(userTrackerObj) {
    try {

      if (userTrackerObj.ticketData && userTrackerObj.ticketData.length) {

        for (var i = 0; i < userTrackerObj.ticketData.length; i++) {

          let shippingid = userTrackerObj.ticketData[i].shippingData.shippingid;
          //  let eventTrack = "EmailerTicket " + userTrackerObj.subReason;
          let inputDataReq = {
            "projectname": userTrackerObj.projectname,
            "type": "web",
            "userid": userTrackerObj.userid,
            "username": userTrackerObj.username,
            "olduserid": userTrackerObj.olduserid,
            "routeurl": userTrackerObj.trackurl,
            "meta": {
              "event": userTrackerObj.eventTrack,
              "shippingid": shippingid
            }
          };
          this.userTracker(inputDataReq);
        }
      }
    } catch (error) {
      console.log("userTrackerBulkEdit Catched Error ", error);
    }

  },


  //      userTrackerBulkCreate  
  async userTrackerBulkCreate(userTrackerObj) {
    try {

      let arrstrShippingIds = userTrackerObj.shippingIds.split(',').map(item => item.trim());

      if (arrstrShippingIds && arrstrShippingIds.length) {

        for (var i = 0; i < arrstrShippingIds.length; i++) {

          let shippingid = arrstrShippingIds[i];
          //  let eventTrack = "EmailerTicket " + userTrackerObj.subReason;
          let inputDataReq = {
            "projectname": userTrackerObj.projectname,
            "type": "web",
            "userid": userTrackerObj.userid,
            "username": userTrackerObj.username,
            "olduserid": userTrackerObj.olduserid,
            "routeurl": userTrackerObj.trackurl,
            "meta": {
              "event": userTrackerObj.eventTrack,
              "shippingid": shippingid
            }
          };
          this.userTracker(inputDataReq);
        }
      }
    } catch (error) {
      console.log("userTrackerBulkCreate Catched Error ", error);
    }

  },

  //#ip_track userTracker for getTrackShipmentSummeryDetails
  async userTrackergetTrackShipmentSummeryDetails(userTrackerObj) {
    try {
      let inputDataReq = {
        "projectname": userTrackerObj.projectname,
        "type": "web",
        "userid": userTrackerObj.userid,
        "username": userTrackerObj.username,
        "olduserid": userTrackerObj.olduserid,
        "routeurl": userTrackerObj.trackurl,
        "meta": {
          "event": userTrackerObj.eventTrack,
          "shippingid": userTrackerObj.shippingId
        }
      };
      this.userTracker(inputDataReq);
  
    } catch (error) {
      console.log("getTrackShipmentSummeryDetails Catched Error ", error);
    }
  },



  async userTrackerEmailer(userTrackerObj) {
    // console.log("userTrackerObj ",JSON.stringify(userTrackerObj));
    // console.log("ticketData -- ",JSON.stringify(userTrackerObj.ticketData));
    if (userTrackerObj.ticketData && userTrackerObj.ticketData.length) {

      for (var i = 0; i < userTrackerObj.ticketData.length; i++) {

        let shippingid = userTrackerObj.ticketData[i].shippingData.shippingid;
        //  let eventTrack = "EmailerTicket " + userTrackerObj.subReason;
        let inputDataReq = {
          "projectname": userTrackerObj.projectname,
          "type": "web",
          "userid": userTrackerObj.userid,
          "username": userTrackerObj.username,
          "olduserid": userTrackerObj.olduserid,
          "routeurl": userTrackerObj.trackurl,
          "meta": {
            "event": userTrackerObj.eventTrack,
            "shippingid": shippingid
          }
        };
        this.userTracker(inputDataReq);
      }
    }
  },


 // userTrackerCSAW
 async userTrackerCSAW(userTrackerObj) {

try {

  if (userTrackerObj.ticketData && userTrackerObj.ticketData.length) {

    for (var i = 0; i < userTrackerObj.ticketData.length; i++) {

      let shippingid = userTrackerObj.ticketData[i].shippingData.shippingid;
      let inputDataReq = {
        "projectname": userTrackerObj.projectname,
        "type": "web",
        "userid": userTrackerObj.userid,
        "username": userTrackerObj.username,
        "olduserid": userTrackerObj.olduserid,
        "routeurl": userTrackerObj.trackurl,
        "meta": {
          "event": userTrackerObj.eventTrack,
          "shippingid": shippingid
        }
      };
      this.userTracker(inputDataReq);
    }
  }
  
 } catch (error) {
  console.log("userTrackerCSAW Catched Error ", error);
}

},


//userTrackerB2BTicket 
async userTrackerB2BTicket(userTrackerObj) {
  try {
    let inputDataReq = {
      "projectname": userTrackerObj.projectname,
      "type": "web",
      "userid": userTrackerObj.userid,
      "username": userTrackerObj.username,
      "olduserid": userTrackerObj.olduserid,
      "routeurl": userTrackerObj.trackurl,
      "meta": {
        "event": userTrackerObj.eventTrack,
        "shippingid": userTrackerObj.shippingIds
      }
    };
    this.userTracker(inputDataReq);

  } catch (error) {
    console.log("userTrackerB2BTicket Catched Error ", error);
  }
},


//userTrackerB2BAppointment 
async userTrackerB2BAppointment(userTrackerObj) {
  try {
    let inputDataReq = {
      "projectname": userTrackerObj.projectname,
      "type": "web",
      "userid": userTrackerObj.userid,
      "username": userTrackerObj.username,
      "olduserid": userTrackerObj.olduserid,
      "routeurl": userTrackerObj.trackurl,
      "meta": {
        "event": userTrackerObj.eventTrack,
        "shippingid": userTrackerObj.shippingIds
      }
    };
    this.userTracker(inputDataReq);

  } catch (error) {
    console.log("userTrackerB2BAppointment Catched Error ", error);
  }
},

//track_security_7627 userTrackerSearchActivity
async userTrackerSearchActivity(userTrackerObj) {
  try {
    let meta = {
      "event": userTrackerObj.eventTrack,
      "searchReason": userTrackerObj.searchReason,
      "searchType": userTrackerObj.searchType,
      "remarks": userTrackerObj.searchPurpose
    };
    
    // Add dynamic field based on searchType
    if (userTrackerObj.searchType === 'TicketID') {
      meta.ticketid = userTrackerObj.shippingIds;
    } else if (userTrackerObj.searchType === 'ClientOrderID') {
      meta.clientOrderId = userTrackerObj.shippingIds;
      if (userTrackerObj.Client) {
        meta.client = userTrackerObj.Client;
      }
    } else {
      meta.shippingid = userTrackerObj.shippingIds;
      // Add sourceClientOrderID for AWB clicks from Client Order ID search
      if (userTrackerObj.sourceClientOrderID) {
        meta.sourceClientOrderID = userTrackerObj.sourceClientOrderID;
      }
    }
    
    let inputDataReq = {
      "projectname": userTrackerObj.projectname,
      "type": "web",
      "userid": userTrackerObj.userid,
      "username": userTrackerObj.username,
      "olduserid": userTrackerObj.olduserid,
      "routeurl": userTrackerObj.trackurl,
      "meta": meta
    };
    this.userTracker(inputDataReq);

  } catch (error) {
    console.log("userTrackerSearchActivity Catched Error ", error);
  }
},
};



// WEBPACK FOOTER //
// ./src/authFunction.js